import React from 'react'
import Home from '../pages/home/Home'
import Layout from './Layout'
import { Routes, Route, Navigate } from "react-router-dom";
import ThankYou from '../pages/thankyou/ThankYou';
import NotFound from '../pages/404/404';
import BlogDetail from '../pages/blogs/detail/BlogDetail';
import PressListing from '../pages/pressRelease/listing/PressListing';
import BlogListing from '../pages/blogs/listing/BlogListing';
import CaseListing from '../pages/caseStudy/listing/CaseListing';
import PressDetail from '../pages/pressRelease/detail/PressDetail';
import About from '../pages/about/About';
import CloudComputing from '../pages/technology/cloudComputing/CloudComputing';
import TermsAndCondition from '../pages/quciklinks/TermsAndCondition';
import Sustainability from '../pages/sustainability/Sustainability';
import Iot from '../pages/technology/iot/Iot';
import TechAI from '../pages/technology/techAI/TechAI';
import InfraCyber from '../pages/technology/infraCyber/InfraCyber';
import DataIntegration from '../pages/technology/dataIntegration/DataIntegration';
import DataAnalytics from '../pages/technology/dataAnalytics/DataAnalytics';
import CaseDetail from '../pages/caseStudy/detail/CaseDetail';
import Team from '../pages/Team/Team';
import FinancialServices from '../pages/industries/financialServices/FinancialServices';
import Healthcare from '../pages/industries/healthcare/Healthcare';
import Educational from '../pages/industries/educational/Educational';
import OtherIndustry from '../pages/industries/otherIndustry/OtherIndustry';
import ScrollToTop from './ScrollToTop';
import ContactUs from '../pages/contactUs/ContactUs';
import MediaService from '../pages/industries/mediaService/MediaService';
import InsuranceServices from '../pages/industries/insuranceServices/InsuranceServices';
import GovernmentServices from '../pages/industries/governmentServices/GovernmentServices';
import CpgRetail from '../pages/industries/cpgRetail/CpgRetail';
// import Location from '../pages/location/Location';
import SmallBusiness from '../pages/industriesMore/smallbusiness/SmallBusiness';
import HumanResources from '../pages/industriesMore/humanresources/HumanResources';
import Finance from '../pages/industriesMore/finance/Finance';
import Sales from '../pages/industriesMore/sales/Sales'
import Enterprises from '../pages/industriesMore/enterprises/Enterprises';
import MobileWorkforce from '../pages/industriesMore/mobileworkforce/MobileWorkforce';
import PhysicalRecords from '../pages/services/physicalrecords/PhysicalRecords';
import AiExtraction from '../pages/services/aiextraction/AiExtraction';
import DigitizationServices from '../pages/services/digitizationservices/DigitizationServices';
import DataPlatform from '../pages/services/dataplatform/DataPlatform';
import DynamicPage from '../pages/dynamicPage/DynamicPage';
import { useModal } from '../contexts/ModalContext';
import EnquiryPopup from '../components/EnquiryPopup';
import Locations from '../pages/locations/Locations';

function Redirect({ to }) {
  if (typeof window !== "undefined") {
    return <Navigate to={to} replace />;
  }
  return null;
}

export default function NavRouter({ initialData }) {
  const { modalShow, closeQueryModal } = useModal();
  return (
    <>
      <ScrollToTop />
      <EnquiryPopup show={modalShow} setShow={closeQueryModal} />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home initialData={initialData} />} />
          <Route path="thank-you" element={<ThankYou />} />
          <Route path="404" element={<NotFound />} />
          <Route path="*" element={<Redirect to="/404" />} />

          {/* Company */}
          <Route path='sustainability' element={<Sustainability />} />
          <Route path="about-us" element={<About />} />
          {/* <Route path="location" element={<Location />} /> */}
          <Route path="location" element={<Locations/>} />
          
          <Route path="team" element={<Team />} />

          {/* Blog Routes */}
          <Route path='blog-details/:slug' element={<BlogDetail initialData={initialData} />} />
          <Route path='blog' element={<BlogListing initialData={initialData} />} />

          {/* Press Release Routes */}
          {/* <Route path='press-release/:slug' element={<PressDetail initialData={initialData} />} />
          <Route path="press-release" element={<PressListing initialData={initialData} />} /> */}

          {/* Case Study Routes */}
          {/* <Route path="case-study" element={<CaseListing initialData={initialData} />} />
          <Route path='case-study/:slug' element={<CaseDetail initialData={initialData} />} /> */}

          {/* Qucik Links */}
          <Route path="terms-condition" element={<TermsAndCondition />} />

          {/* Tecnologies*/}
          <Route path="iot-enabled" element={<Iot />} />
          <Route path="artificial-intelligence" element={<TechAI />} />
          <Route path="infrastructure" element={<InfraCyber />} />
          <Route path="data-integration-visibility" element={<DataIntegration />} />
          <Route path="data-analytics" element={<DataAnalytics />} />
          <Route path="cloud-computing" element={<CloudComputing />} />


          {/* Industry Routes */}
          <Route path="financial-institutions" element={<FinancialServices />} />
          <Route path="media-entertainment-records-management" element={<MediaService />} />
          <Route path="insurance-document-management-services" element={<InsuranceServices />} />
          <Route path="government-records-management-services" element={<GovernmentServices />} />
          <Route path="cpg-retail-records-management" element={<CpgRetail />} />
          <Route path="healthcare" element={<Healthcare />} />
          <Route path="education-training" element={<Educational />} />
          <Route path="other-industries-we-serve" element={<OtherIndustry />} />

          {/* Contact Us */}
          <Route path="contact" element={<ContactUs />} />

          {/* Industries More*/}
          <Route path='hr-document-management-services' element={<HumanResources />} />
          <Route path='small-business-solution' element={<SmallBusiness initialData={initialData}/>} />
          <Route path='finance-document-management-services' element={<Finance />} />
          <Route path='sales-document-management-solutions' element={<Sales />} />
          <Route path='enterprise-document-management-solutions' element={<Enterprises initialData={initialData}/>} />
          <Route path='mobile-workforce-document-solutions' element={<MobileWorkforce initialData={initialData}/>} />

          {/* Services */}
          <Route path='physical-records-management-services' element={<PhysicalRecords />} />
          <Route path='ai-document-data-extraction' element={<AiExtraction />} />
          <Route path='document-digitization' element={<DigitizationServices />} />
          <Route path='data-privacy-governance-compliance-platform' element={<DataPlatform />} />
          <Route path='/:dynamicpage_slug' element={<DynamicPage initialData={initialData} />} />
        </Route>
      </Routes>
    </>
  )
}
